var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2754 8.96002L14.3242 1.00476C13.6836 0.435515 12.8564 0.121094 11.9994 0.121094C11.1424 0.121094 10.3152 0.435515 9.67459 1.00476L0.724624 8.96002C0.54826 9.11745 0.423831 9.32469 0.367789 9.55436C0.311748 9.78402 0.326733 10.0253 0.410764 10.2462C0.494795 10.4672 0.643914 10.6575 0.838402 10.7919C1.03289 10.9262 1.26359 10.9984 1.49999 10.9989H3.83332V19.1656C3.83434 20.0935 4.20342 20.9832 4.85958 21.6393C5.51573 22.2955 6.40538 22.6645 7.33332 22.6656H8.49999V15.6656C8.49999 11.0409 15.5 11.0388 15.5 15.6656V22.6656H16.6667C17.5946 22.6645 18.4842 22.2955 19.1404 21.6393C19.7966 20.9832 20.1656 20.0935 20.1667 19.1656V10.9989H22.5C22.7364 10.9984 22.9671 10.9262 23.1616 10.7919C23.3561 10.6575 23.5052 10.4672 23.5892 10.2462C23.6732 10.0253 23.6882 9.78402 23.6322 9.55436C23.5762 9.32469 23.4517 9.11745 23.2754 8.96002Z",
    fill: "#091F82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.09241a3e36c6c815bd583637ff8e0d45.svg";
export { ForwardRef as ReactComponent };